import { jsx as _jsx } from "react/jsx-runtime";
import ThemeSelector from './ThemeSelector';
export default function withThemeSelector(Component, 
// The default color to use when props.color isn't provided. If this isn't set
// it will inherit the current color from context.
defaultColor) {
    const WrappedComponent = (props) => {
        if (!props.color && !defaultColor)
            return _jsx(Component, Object.assign({}, props));
        return (_jsx(ThemeSelector, Object.assign({ color: props.color || defaultColor }, { children: _jsx(Component, Object.assign({}, props)) })));
    };
    return WrappedComponent;
}
//# sourceMappingURL=withThemeSelector.js.map